// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marking-demo {
  border: 1px solid #e1e6ef;
  border-radius: 16px;
  padding: 16px;
  background: white;
  margin-bottom: 14px;
  color: #232137;
}
.marking-demo button {
  min-height: 44px;
  font-size: 13px;
  line-height: 1.35;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}
.marking-demo .marking-demo-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.marking-demo .marking-demo-heading > span {
  font-size: 11px;
  color: #e72f44;
}
.marking-demo .marking-demo-heading button {
  background: #edf1f6;
  color: #3e4860;
  padding: 8px 12px;
}
.marking-demo .marking-demo-steps {
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0 0 20px;
  gap: 6px;
}
.marking-demo .marking-demo-steps li {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #78849a;
}
.marking-demo .marking-demo-steps b {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: #edf1f6;
  flex-shrink: 0;
}
.marking-demo .marking-demo-steps li.active {
  color: #e72f44;
}
.marking-demo .marking-demo-steps li.active b {
  background: #fff1f4;
}
.marking-demo h2 {
  font-size: 18px;
  margin: 0 0 10px;
  letter-spacing: -0.02em;
}
.marking-demo p {
  font-size: 13px;
  line-height: 1.6;
  margin: 10px 0;
}
.marking-demo .marking-demo-primary {
  background: #e72f44;
  color: white;
  padding: 10px 14px;
  width: 100%;
  margin-top: 6px;
}
.marking-demo .marking-demo-product {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border: 1px solid #e1e6ef;
  border-radius: 12px;
  background: #f8fafd;
  margin-block: 14px;
}
.marking-demo .marking-demo-product > div {
  display: grid;
  gap: 5px;
  min-width: 0;
}
.marking-demo .marking-demo-product strong {
  font-size: 14px;
}
.marking-demo .marking-demo-product small {
  font-size: 11px;
  color: #78849a;
}
.marking-demo .marking-demo-product div > span {
  font-size: 11px;
  color: #a77736;
}
.marking-demo .marking-demo-product-icon {
  font-size: 32px;
  color: #78849a;
}
.marking-demo .marking-demo-camera {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: #f1f4f9;
  border-radius: 12px;
  padding: 16px;
  margin-block: 14px;
}
.marking-demo .marking-demo-camera > span {
  font-size: 10px;
  color: #78849a;
}
.marking-demo .marking-demo-code {
  color: #232137;
  background: white;
  border: 2px solid #e72f44;
  border-radius: 10px;
  width: 112px;
  height: 112px;
  padding: 14px;
  box-sizing: border-box;
}
.marking-demo .marking-demo-code svg {
  display: block;
  width: 100%;
  height: 100%;
  shape-rendering: crispEdges;
}
.marking-demo .marking-demo-done {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  background: #edf7f1;
  border-radius: 16px;
  font-size: 28px;
  color: #32775b;
  margin-bottom: 14px;
}
.marking-demo .marking-demo-note {
  border-top: 1px solid #edf0f5;
  padding-top: 12px;
  margin-top: 14px;
  font-size: 11px;
  color: #78849a;
}

.terminal-marking-guide {
  background: white;
  border: 1px solid #e1e6ef;
  border-radius: 16px;
  padding: 14px;
  margin-bottom: 14px;
}
.terminal-marking-guide h2 {
  margin: 0 0 6px;
  font-size: 16px;
}
.terminal-marking-guide p {
  font-size: 12px;
  line-height: 1.6;
  color: #78849a;
  margin: 0 0 10px;
}
.terminal-marking-guide button {
  min-height: 44px;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  background: #edf1f6;
  color: #3e4860;
}`, "",{"version":3,"sources":["webpack://./src/pages/TerminalMarkingPage/markingDemo.scss"],"names":[],"mappings":"AAAA;EAAgB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,iBAAA;EAAmB,mBAAA;EAAqB,cAAA;AAOvH;AANE;EAAS,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;EAAmB,YAAA;EAAc,mBAAA;EAAqB,eAAA;AAcpG;AAbE;EAAwB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,mBAAA;AAoBxG;AApB6H;EAAS,eAAA;EAAiB,cAAA;AAwBvJ;AAxByK;EAAS,mBAAA;EAAqB,cAAA;EAAgB,iBAAA;AA6BvN;AA5BE;EAAsB,gBAAA;EAAkB,aAAA;EAAe,8BAAA;EAAgC,UAAA;EAAY,gBAAA;EAAkB,QAAA;AAoCvH;AApCiI;EAAK,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,cAAA;AA2CrM;AA3CuN;EAAI,oBAAA;EAAsB,uBAAA;EAAyB,mBAAA;EAAqB,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,cAAA;AAqDnW;AArDqX;EAAY,cAAA;AAwDjY;AAxDiZ;EAAI,mBAAA;AA2DrZ;AA1DE;EAAK,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AA+D1C;AA/DoE;EAAI,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAoE3G;AAnEE;EAAwB,mBAAA;EAAqB,YAAA;EAAc,kBAAA;EAAoB,WAAA;EAAa,eAAA;AA0E9F;AAzEE;EAAwB,aAAA;EAAe,SAAA;EAAW,mBAAA;EAAqB,aAAA;EAAe,yBAAA;EAA2B,mBAAA;EAAqB,mBAAA;EAAqB,kBAAA;AAmF7J;AAnFiL;EAAQ,aAAA;EAAe,QAAA;EAAU,YAAA;AAwFlN;AAxFkO;EAAS,eAAA;AA2F3O;AA3F8P;EAAQ,eAAA;EAAiB,cAAA;AA+FvR;AA/FyS;EAAa,eAAA;EAAiB,cAAA;AAmGvU;AAlGE;EAA6B,eAAA;EAAiB,cAAA;AAsGhD;AArGE;EAAuB,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,SAAA;EAAW,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,kBAAA;AA+GzJ;AA/G6K;EAAS,eAAA;EAAiB,cAAA;AAmHvM;AAlHE;EAAqB,cAAA;EAAgB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,YAAA;EAAc,aAAA;EAAe,aAAA;EAAe,sBAAA;AA4HtJ;AA5H8K;EAAM,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,2BAAA;AAkI/N;AAjIE;EAAqB,aAAA;EAAe,uBAAA;EAAyB,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,eAAA;EAAiB,cAAA;EAAgB,mBAAA;AA6I1L;AA5IE;EAAqB,6BAAA;EAA+B,iBAAA;EAAmB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAmJ5G;;AAjJA;EAA0B,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AAyJ5G;AAzJiI;EAAK,eAAA;EAAiB,eAAA;AA6JvJ;AA7J0K;EAAI,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,gBAAA;AAmKjO;AAnKqP;EAAS,gBAAA;EAAkB,YAAA;EAAc,mBAAA;EAAqB,kBAAA;EAAoB,eAAA;EAAiB,mBAAA;EAAqB,cAAA;AA4K7W","sourcesContent":[".marking-demo { border: 1px solid #e1e6ef; border-radius: 16px; padding: 16px; background: white; margin-bottom: 14px; color: #232137;\n  button { min-height: 44px; font-size: 13px; line-height: 1.35; border: none; border-radius: 10px; cursor: pointer; }\n  .marking-demo-heading { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 10px; > span { font-size: 11px; color: #e72f44; } button { background: #edf1f6; color: #3e4860; padding: 8px 12px; } }\n  .marking-demo-steps { list-style: none; display: flex; justify-content: space-between; padding: 0; margin: 0 0 20px; gap: 6px; li { display: flex; align-items: center; gap: 6px; font-size: 11px; color: #78849a; } b { display: inline-flex; justify-content: center; align-items: center; border-radius: 50%; width: 24px; height: 24px; background: #edf1f6; flex-shrink: 0; } li.active { color: #e72f44; b { background: #fff1f4; } } }\n  h2 { font-size: 18px; margin: 0 0 10px; letter-spacing: -.02em; } p { font-size: 13px; line-height: 1.6; margin: 10px 0; }\n  .marking-demo-primary { background: #e72f44; color: white; padding: 10px 14px; width: 100%; margin-top: 6px; }\n  .marking-demo-product { display: flex; gap: 12px; align-items: center; padding: 12px; border: 1px solid #e1e6ef; border-radius: 12px; background: #f8fafd; margin-block: 14px; > div { display: grid; gap: 5px; min-width: 0; } strong { font-size: 14px; } small { font-size: 11px; color: #78849a; } div > span { font-size: 11px; color: #a77736; } }\n  .marking-demo-product-icon { font-size: 32px; color: #78849a; }\n  .marking-demo-camera { display: flex; flex-direction: column; align-items: center; gap: 12px; background: #f1f4f9; border-radius: 12px; padding: 16px; margin-block: 14px; > span { font-size: 10px; color: #78849a; } }\n  .marking-demo-code { color: #232137; background: white; border: 2px solid #e72f44; border-radius: 10px; width: 112px; height: 112px; padding: 14px; box-sizing: border-box; svg { display: block; width: 100%; height: 100%; shape-rendering: crispEdges; } }\n  .marking-demo-done { display: flex; justify-content: center; align-items: center; width: 52px; height: 52px; background: #edf7f1; border-radius: 16px; font-size: 28px; color: #32775b; margin-bottom: 14px; }\n  .marking-demo-note { border-top: 1px solid #edf0f5; padding-top: 12px; margin-top: 14px; font-size: 11px; color: #78849a; }\n}\n.terminal-marking-guide { background: white; border: 1px solid #e1e6ef; border-radius: 16px; padding: 14px; margin-bottom: 14px; h2 { margin: 0 0 6px; font-size: 16px; } p { font-size: 12px; line-height: 1.6; color: #78849a; margin: 0 0 10px; } button { min-height: 44px; border: none; border-radius: 10px; padding: 10px 14px; font-size: 13px; background: #edf1f6; color: #3e4860; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
